
import { BaseComponent } from '@/decorators';
import { Component } from 'vue-property-decorator';
import api from '@/utils/api'
import CheckForm from './Check.vue'
import dayjs from 'dayjs';
@Component({
    components: { CheckForm }
})
export default class LeaveIndex extends BaseComponent {
    mode = '待处理';
    Model = {
        name: '',
        start: null,
        end: null,
        traffic: null,
        pass: null,
        passCode: null,
        to: null,
        toCode: null,
        type: null,
        reason: null,
        entourage: '' ,
        Ens:new Array<any>(),
        dayCount: 0,
    }
    Title = "出差申请";
    Cols = [
        { slot: 'templateName', minWidth: 130, title: '名称' },
        { slot: 'tripType', title: '出差类型', maxWidth: 95, minWidth: 95, },
        { key: 'to', title: '目的地', minWidth: 95, },
        { slot: 'start', title: '出发日期', minWidth: 128, maxWidth: 128 },
        { slot: 'end', title: '返回日期', minWidth: 128, maxWidth: 128 },
        { title: '出差事由', slot: 'leaveReason', minWidth: 200, show: true },
        { slot: 'status', title: '状态', minWidth: 108, maxWidth: 108, },
        { slot: 'nodeUserName', title: '当前节点', minWidth: 100, maxWidth: 100, },
        { title: '创建时间', slot: 'createdTime', minWidth: 180, maxWidth: 180, show: true },
        { slot: 'action', title: '操作', minWidth: 145, maxWidth: 145 ,fixed:'right'},
    ];
    HD: any = [
        // { key: "130402", label: "邯山区" },
        // { key: "130403", label: "丛台区" },
        // { key: "130404", label: "复兴区" },
        { key: "130405", label: "冀南新区" },
        { key: "130406", label: "峰峰矿区" },
        // { key: "130421", label: "邯郸县" },
        { key: "130423", label: "临漳县" },
        { key: "130424", label: "成安县" },
        { key: "130425", label: "大名县" },
        { key: "130426", label: "涉县" },
        { key: "130427", label: "磁县" },
        { key: "130428", label: "肥乡区" },
        { key: "130429", label: "永年区" },
        { key: "130430", label: "邱县" },
        { key: "130431", label: "鸡泽县" },
        { key: "130432", label: "广平县" },
        { key: "130433", label: "馆陶县" },
        { key: "130434", label: "魏县" },
        { key: "130435", label: "曲周县" },
        { key: "130481", label: "武安市" }
    ];
    Loading = true;
    List = new Array<any>();


    async mounted() {
        await this.Init();
    }

    async Init() {
        this.mode = this.mode;
        this.Query = { name: ''};
        this.ChangeMode(this.mode);
        this.Model = {
            name: '',
            start: null,
            end: null,
            traffic: null,
            pass: null,
            passCode: null,
            to: null,
            toCode: null,
            type: null,
            reason: null,
            entourage: '' ,
            Ens:new Array<any>(),
            dayCount: 0,
        }
        this.IsEdit = false;
        this.Row = null;
        this.$refs.PageView.showModal = false;
        this.InitPager();
    }
    async ChangeMode(e: string) {
        if (e == '待处理')
            this.Query.mode = 0;
        if (e == '已处理')
            this.Query.mode = 1;
        if (e == '我发起的')
            this.Query.mode = 2;
        if (e == '全部')
            this.Query.mode = 3;

        await this.FetchData();
    }

    async FetchData() {
        this.Loading = true;
        let res = await api.Trip.Query(this.Pager, this.Query);
        if (res.status == 200) {
            this.List = [...res.data.data];
            this.Pager.total = res.data.count;
            this.Loading = false;
            for(let item of this.List){
                item.Ens = item.entourage?.split(',');
            }
        }
    }

    async Save() {
        if (this.Model.Ens) {
            this.Model.entourage = this.Model.Ens.join(',');
        }
        let res;
        if (this.IsEdit) {
            res = await api.Trip.Edit({ id: this.Row.id,
                ...this.Model
            });

        } else {
            res = await api.Trip.Create(this.Model);
        }

        if (res.status == 200 || res.status == 201) {
            this.$Notice.success({ title: '保存成功!' });
            await this.Init();
        }
    }
    async Publish() {
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Trip.Publish(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }

    async Reject() {
        if (!this.Remark) {
            this.$Message.error('请输入驳回原因');
            return;
        }
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Trip.Reject(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }

    OpenCheck(row: any) {
        this.Row = { ...row };
        this.ShowDrawer = true;
    }
    CloseCheck() {
        this.ShowDrawer = false;
        this.Remark = '';
        this.Row = null;
    }
    OpenCancelModal(id: any) {
        this.$Modal.confirm({
            title: '提示',
            content: '当前申请已在审批流程中，确认是否取消当前申请？',
            onOk: async () => {
                let res = await api.Trip.Cancel(id);
                if (res.status == 200 && res.data) {
                    await this.Init();
                    this.$Notice.success({ title: '撤销成功' });
                } else {
                    this.$Notice.error({ title: '撤销失败' });
                }

            }
        });
    }
    OpenEditModal(row: any) {
        this.$refs.PageView.showModal = true;
        this.IsEdit = true;
        this.Model = { ...row };
        this.Row = { ...row };
        this.Title = "编辑出差申请";
    }
    OpenModal() {
        this.$refs.PageView.showModal = true;
        this.Title = "出差申请";
    }
    OVC(e: boolean) {
        if (e) {
            // this.Model.Ens = this.Model.entourage.split(',');
        } else {
            this.Model = {
                name: '',
                start: null,
                end: null,
                traffic: null,
                pass: null,
                passCode: null,
                to: null,
                toCode: null,
                type: null,
                reason: null,
                entourage: '' ,
                Ens:new Array<any>(),
                dayCount: 0,
            }
        }
    }

    options3: any = {
        disabledDate: (date: Date) => {
            return date && date.valueOf() < Date.now() - 86400000;
        }
    };

    GetDuration(duration: string) {
        if (this.Model.start && this.Model.end) {
            this.Model.dayCount = dayjs(this.Model.end).diff(this.Model.start, 'day') + 1;
        }
    }

    onSelectHD(item: any) {
       //  console.log(item);
        this.Model.to = item.label;
    }

    onToChange(item: any) {
       //  console.log(item);
        this.Model.to = item.n;
    }

    onPassChange(item: any) {
        //  console.log(item);
        this.Model.pass = item.n;
    }

    onTypeChange(item: any){
       //  console.log(this.Model.type);
        if (this.Model.type==1){
            this.Model.to = null;
            this.Model.toCode = null;
            this.Model.pass = null;
            this.Model.passCode = null;

        }
    }

}
